import {Resource} from './resources.datatypes';
import {Group} from './groups.datatypes';
import {BillingParty} from './billing_party.datatypes';

export interface PaymentSchedule {
    __typename?: string | undefined,
    id: number
    description: string
    dates: PaymentScheduleDate[]
    payment_dates: PaymentScheduleDate[]

    tour?: Resource
    group?: Group
    billing_party?: BillingParty
}

export interface PaymentScheduleDate {
    __typename?: string | undefined,
    id: number
    payment_schedule_id?: number
    title?: string
    due_date?: string
    action_type?: number
    amount?: number
    amount_type?: number
    completed?: boolean

    schedule?: PaymentSchedule
    calculatedAmount?: number
}

export const PaymentScheduleAction = {
    PAYMENT: 0,
    SOFT_CANCELLATION: 1,
    CANCELLATION: 2,
};

export const PaymentScheduleActions = [
    {name: 'payment'},
    {name: 'soft cancellation'},
    {name: 'cancellation'},
];

export const PaymentScheduleAmountType = {
    FIXED: 0,
    PERCENT: 1,
    FIXED_PER_PERSON: 2,
    PERCENT_PER_PERSON: 3,
    REMAINING: 4,
};

export const PaymentScheduleAmountTypes = [
    {name: '$'},
    {name: '%'},
    {name: '$ pp'},
    {name: '% pp'},
    {name: 'Rem'},
];
